/**
 * Segmentos que cobra un SMS: GSM-7 admite 160 caracteres en uno solo y 153 por segmento al
 * concatenar; con cualquier carácter fuera de GSM-7 (acentos como á, emoji) pasa a UCS-2: 70 y 67.
 */
const GSM7 =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà^{}\\[~]|€";

export function segmentosSms(texto: string): { segmentos: number; unicode: boolean } {
  if (texto.length === 0) return { segmentos: 0, unicode: false };
  const unicode = [...texto].some((c) => !GSM7.includes(c));
  const [uno, varios] = unicode ? [70, 67] : [160, 153];
  const largo = [...texto].length;
  return { segmentos: largo <= uno ? 1 : Math.ceil(largo / varios), unicode };
}
